module.exports = __webpack_public_path__ + "img/cheveronUpBlue.0994f62e.svg";